// extracted by mini-css-extract-plugin
export var button = "ButtonGhost-module--button--NO2X2";
export var lightTheme = "ButtonGhost-module--lightTheme--I32BD";
export var text = "ButtonGhost-module--text--OYAXV";